import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useInputSelectionStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        marginTop: theme.spacing(1),
      },
      stepArea: {
        marginTop: theme.spacing(2),
        marginLeft: '2%',
        marginRight: '2%',
      },
      step: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: theme.palette.background.paper,
      },
      buttons: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: theme.spacing(2),
      },
    }),
  )